import { httpService } from '@/api/v1/http.service'
import { nextPageParamGetter } from '@/utils/next-page-param-getter'

import type { InfiniteQueryOptions } from '../types/infinite-query'
import type { LabelAndValue } from '../types/label-and-value'
import { parsePaginatedOptions } from '../utils/parse-paginated'

export const languagesQueryOptions = (
  search?: string
): InfiniteQueryOptions<LabelAndValue> => ({
  queryKey: ['panelUsersOptionsLanguagesList', search],
  staleTime: 60 * 100,
  queryFn: ({ pageParam }) =>
    httpService.panel
      .panelUsersOptionsLanguagesList({
        search,
        page: pageParam
      })
      .then(parsePaginatedOptions),
  getNextPageParam: nextPageParamGetter,
  initialPageParam: 1
})
